<template>
  <div class="menu-item text-left d-flex" v-on="$listeners">
    <centered-container horizontal="left" :class="['w-' + textWidth]">
      <span :class="[{link:asLink}]" v-if="text">{{text}}</span>
    </centered-container>
    <centered-container v-if="nav" class="w-10 nav">
      <cms-icon width="15" height="15">
        <icon-arrow />
      </cms-icon>
    </centered-container>
  </div>
</template>

<script>
import arrowNav from "../icons/arrow-nav";

export default {
  name: "cms-menu-item",
  components: {
    "icon-arrow": arrowNav
  },
  props: {
    text: {
      type: String,
      default: ""
    },
    asLink: {
      type: Boolean,
      default: false
    },
    nav: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textWidth() {
      return this.nav ? 90 : 100;
    }
  }
};
</script>

<style scoped lang="scss">
.menu-item {
  height: 3.2rem;
  width: 100%;
}

span.link {
  color: $dark-sky-blue-color;
}

.nav {
  color: $dark-sky-blue-color;
}
</style>
